import { Skeleton } from '@/components/ui/skeleton'

export default function BlueprintCardSkeleton() {
  return (
    <div className="rounded-lg border bg-card p-6">
      <Skeleton className="mb-2 h-7 w-3/4" />
      <Skeleton className="mb-4 h-4 w-full" />
      <Skeleton className="h-4 w-full" />
      <div className="mt-4 flex items-center gap-4">
        <Skeleton className="h-6 w-16" />
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-24" />
      </div>
    </div>
  )
}
